import { render, staticRenderFns } from "./orderPrintingDetails.vue?vue&type=template&id=b05bea94&scoped=true&"
import script from "./orderPrintingDetails.vue?vue&type=script&lang=js&"
export * from "./orderPrintingDetails.vue?vue&type=script&lang=js&"
import style0 from "./orderPrintingDetails.vue?vue&type=style&index=0&id=b05bea94&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b05bea94",
  null
  
)

export default component.exports